import ContactsDuplicatesExtendedListViewCtrl from '../../../../store/contacts/controllers/duplicates-extended-list-view';

angular
    .module('festzelt-os.guestlists')
    .controller('ContactsDuplicatesExtendedListViewCtrl', [
        '$injector',
        '$scope',
        ($injector, $scope) => new ContactsDuplicatesExtendedListViewCtrl($injector, $scope)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/store/duplicates-extended-listview.js